export enum FormFieldGroupId {
  PRODUCT = 'product',
  HEATER = 'heater',
  POWER = 'power',
  HOUSEHOLD = 'household',
  OBJECT = 'object',
  OTHER = 'other',
  CONTACT = 'contact',
}
